import React, { Suspense, useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const RealtimeModule = React.lazy(() => import('./AdminRealtimeModule').then((m) => ({ default: m.AdminRealtimeModule })));
const UsersModule = React.lazy(() => import('./AdminUsersModule').then((m) => ({ default: m.AdminUsersModule })));
const SystemModule = React.lazy(() => import('./AdminSystemModule').then((m) => ({ default: m.AdminSystemModule })));
const LogsModule = React.lazy(() => import('./AdminLogsModule').then((m) => ({ default: m.AdminLogsModule })));
const StatsModule = React.lazy(() => import('./AdminStatsModule').then((m) => ({ default: m.AdminStatsModule })));

type AdminTabKey = 'realtime' | 'users' | 'system' | 'logs' | 'stats';

const TABS: Array<{ key: AdminTabKey; label: string }> = [
  { key: 'realtime', label: '实时管理' },
  { key: 'users', label: '用户管理' },
  { key: 'system', label: '系统配置' },
  { key: 'logs', label: '日志审计' },
  { key: 'stats', label: '数据统计' }
];

function parseAdminTab(pathname: string): AdminTabKey | null {
  const m = pathname.match(/^\/profile\/admin\/([a-z-]+)$/i);
  const key = String(m ? m[1] : '').toLowerCase();
  if (key === 'realtime' || key === 'users' || key === 'system' || key === 'logs' || key === 'stats') return key;
  return null;
}

export function AdminWorkspace({ isAdmin }: { isAdmin: boolean }) {
  const location = useLocation();
  const navigate = useNavigate();
  const current = parseAdminTab(location.pathname);
  const [loadedTabs, setLoadedTabs] = useState<Record<AdminTabKey, boolean>>({
    realtime: false,
    users: false,
    system: false,
    logs: false,
    stats: false
  });

  useEffect(() => {
    if (!isAdmin || !current) return;
    setLoadedTabs((prev) => (prev[current] ? prev : { ...prev, [current]: true }));
  }, [current, isAdmin]);

  if (!isAdmin) return <div className="muted">无权限</div>;
  if (!current) return <Navigate to="/profile/admin/users" replace />;

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div className="tool">
        <div className="tool-top">
          <div className="tool-name">管理标签页</div>
          <span className="badge">路由隔离 + 懒加载 + 缓存</span>
        </div>
        <div className="row" style={{ marginTop: 10, gap: 8, flexWrap: 'wrap' }}>
          {TABS.map((it) => (
            <button
              key={it.key}
              className={`btn ${current === it.key ? '' : 'secondary'}`}
              type="button"
              onClick={() => navigate(`/profile/admin/${it.key}`, { replace: false })}
            >
              {it.label}
            </button>
          ))}
        </div>
      </div>

      <Suspense fallback={<div className="muted">加载中…</div>}>
        {loadedTabs.realtime ? <div style={{ display: current === 'realtime' ? 'block' : 'none' }}><RealtimeModule /></div> : null}
        {loadedTabs.users ? <div style={{ display: current === 'users' ? 'block' : 'none' }}><UsersModule /></div> : null}
        {loadedTabs.system ? <div style={{ display: current === 'system' ? 'block' : 'none' }}><SystemModule /></div> : null}
        {loadedTabs.logs ? <div style={{ display: current === 'logs' ? 'block' : 'none' }}><LogsModule /></div> : null}
        {loadedTabs.stats ? <div style={{ display: current === 'stats' ? 'block' : 'none' }}><StatsModule /></div> : null}
      </Suspense>
    </div>
  );
}
